// eslint-disable-next-line import/prefer-default-export
export const contragentSkeletonItems = [
  {
    height: 64,
    width: '80%',
    marginBottom: 8,
  },
  {
    height: 16,
    width: '40%',
    marginBottom: 4,
  },
  {
    height: 14,
    width: '60%',
    marginBottom: 32,
  },
  {
    height: 16,
    width: '40%',
    marginBottom: 4,
  },
  {
    height: 14,
    width: '60%',
    marginBottom: 32,
  },
  {
    height: 16,
    width: '40%',
    marginBottom: 4,
  },
  {
    height: 14,
    width: '60%',
    marginBottom: 32,
  },
  {
    height: 16,
    width: '40%',
    marginBottom: 4,
  },
  {
    height: 14,
    width: '60%',
    marginBottom: 32,
  },
  {
    height: 16,
    width: '40%',
    marginBottom: 4,
  },
  {
    height: 14,
    width: '60%',
    marginBottom: 32,
  },
  {
    height: 16,
    width: '40%',
    marginBottom: 4,
  },
  {
    height: 14,
    width: '60%',
    marginBottom: 32,
  },
];
